<script>
  /**
   * TODO: Verificar existência do CPF ou CNPJ antes de cadastrar a nova pessoa, isso pode gerar conflitos. Se o CPF existir, relacionar login com o cadastro existente
   */
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/usuarios/services'
  import { isArray } from 'lodash'
  import { REAL_BRL } from '../../../../utils/helpers/money'
  import { VMoney } from 'v-money'
  import * as Status from '../../../../domain/usuarios/helpers/PessoaStatus'

  let templates = {
    endereco: {
      bairro: null,
      logradouro: null,
      numero: null,
      complemento: null,
      cep: null,
      cidadeOutros: null,
      ufOutros: null
    },
    telefone: {
      telefone: null
    }
  }

  export default {
    components: {},
    nome: 'usuario',
    directives: {mask, money: VMoney},
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        forcarAlterarSenhaPrimeiroAcesso: true,
        permitidoSomenteConsultaReboque: false,
        data: {
          id: null,
          username: null,
          password: null,
          email: null,
          roles: null,
          pessoa: {
            id: null,
            nome: null,
            tipo: 1,
            classificacao: null,
            nacionalidade: '',
            pfCpf: null,
            pfDataNascimento: null,
            pfEstadoCivil: '',
            pfFiliacaoNomeMae: null,
            pfFiliacaoNomePai: null,
            pfRg: null,
            pfRgDataExpedicao: null,
            pfRgOrgaoEmissor: null,
            pfSexo: '',
            pfTratamento: null,
            pjCnpj: null,
            pjInscricaoEstadual: null,
            pjNomeFantasia: null,
            pjRazaoSocial: null,
            pjResponsavel: null,
            origem: null,
            emails: null,
            enderecos: [],
            telefones: []
          }
        }
      }
    },
    computed: {
      getTemplates () {
        return templates
      },
      getStatus () {
        return Status
      }
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          service.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              this.permitidoSomenteConsultaReboque = response.data.somenteConsultaReboque
              this.ajustaValores()
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          // this.$loaderOverlay.open().message('Aguarde')
          this.isLoaded = true
        }
      },
      transformDataToSend (originData) {
        let data = Object.assign({}, originData)
        // Ajusta endereços
        if (data.pessoa.enderecos && data.pessoa.enderecos.length > 0) {
          data.pessoa.enderecos.forEach((el) => {
            if (el.finalidade && typeof el.finalidade['id'] !== 'undefined') {
              el.finalidade = el.finalidade.id
            }
          })
        }
        return data
      },
      ajustaValores (inversed) {
        inversed = inversed || false
        if (inversed) {
          console.log('Inversed fields to data')
        } else {
          /* if (this.data.pessoa.enderecos) {
            // TODO: Aplicar seleção de UF / Cidade nesta área
            let endereco = this.data.pessoa.enderecos.slice().shift()
            endereco.cidade = endereco.uf && typeof endereco.uf['municipio'] !== 'undefined' ? endereco.uf.municipio.nome : endereco.cidadeOutros
            endereco.uf = endereco.uf && typeof endereco.uf['nome'] !== 'undefined' ? endereco.uf.nome : endereco.ufOutros
            this.endereco = endereco
          } */
          /* if (this.data.pessoa.telefones) {
            this.data.pessoa.telefones.forEach((el, index) => {
              this.telefones['telefone' + (index + 1)] = el.telefone
            })
          } */
          if (this.data.pessoa.pfDataNascimento) {
            let date = this.data.pessoa.pfDataNascimento.date.split(' ').shift().split('-')
            this.data.pessoa.pfDataNascimento = date[2] + '/' + date[1] + '/' + date[0]
          }
          if (this.data.pessoa.pfRgDataExpedicao) {
            let date = this.data.pessoa.pfRgDataExpedicao.date.split(' ').shift().split('-')
            this.data.pessoa.pfRgDataExpedicao = date[2] + '/' + date[1] + '/' + date[0]
          }
        }
      },
      submit () {
        this.ajustaValores(true) // inversed
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)

        let params = {}
        const {policial, reboquista} = this.$route.query
        if (policial) {
          params.policial = policial
        }
        if (reboquista) {
          params.reboquista = reboquista
        }
        if (this.forcarAlterarSenhaPrimeiroAcesso) {
          params.primeiroAcesso = true
        }
        if (this.permitidoSomenteConsultaReboque) {
          params.permitidoSomenteConsultaReboque = true
        }

        service.cadastro(this.transformDataToSend(this.data), this.$route.params.id, this.montaParametros(params))
          .then((response) => {
            let callbackEnd = () => {
              this.$bar.finish()
              this.$loaderOverlay.hide()
              if (this.$route.params.id) {
                // Continua na mesma tela de edição
                // this.$nextTick(() => {
                this.start()
                this.atualizadoSucesso = true
                this.$el.querySelector('#sucessMsg').focus()
                // })
              } else {
                // Redirecionr para tela de visualização do arrematante
                this.$router.push({name: 'usuarios.visualizar', params: {id: response.data.id}})
              }
            }
            callbackEnd()
          }).catch((response) => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            this.cadastroError = response.data.errors
            this.$nextTick(() => {
              this.$refs.error.focus()
            })
            console.log(response)
          })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      montaParametros (parametros = {}) {
        let mount = ''
        for (let key in parametros) {
          if (parametros.hasOwnProperty(key)) {
            const val = parametros[key]
            if (val !== null) {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Usuários Intranet</h1></div>
          <div class="col-sm-6">
            <router-link v-if="data.id" :to="{name: 'usuarios.visualizar', params: {id: data.id}}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso"
                 class="alert alert-success">
              <div class="font-bold">Atualizado com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-2 control-label">Tipo</label>
                <div class="col-sm-10">
                  <input type="radio" id="tipoPessoaFisica" v-model="data.pessoa.tipo" :value="1"/> <label
                  for="tipoPessoaFisica">Física</label> &nbsp;
                  <input type="radio" id="tipoPessoaJuridica" v-model="data.pessoa.tipo" :value="2"/> <label
                  for="tipoPessoaJuridica">Jurídica</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Nome</label>
                <div class="col-sm-10">
                  <input type="text" v-model="data.pessoa.nome" class="form-control"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Login</label>
                <div class="col-sm-10">
                  <input type="text" v-model="data.username" class="form-control"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Email Login</label>
                <div class="col-sm-10">
                  <input type="text" v-model="data.email" class="form-control"/>
                </div>
              </div>

              <div class="form-group" v-if="!data.id">
                <label class="col-sm-2 control-label">Senha de acesso</label>
                <div class="col-sm-10">
                  <input type="text" v-model="data.password" class="form-control"/>
                  <a @click="data.password = Math.random().toString(36).slice(-8)" class="btn btn-xs btn-default m-t-xs"><i class="fa fa-lock m-l-xs m-r-xs"></i> Gerar senha</a>
                </div>
              </div>

              <div v-if="data.pessoa.tipo === 1">
                <!-- FÍSICA -->
                <div class="form-group">
                  <label class="col-sm-2 control-label">CPF</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pessoa.pfCpf" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Nascimento</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pessoa.pfDataNascimento" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">RG</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-4">
                        <input type="text" v-model="data.pessoa.pfRg" class="form-control"/>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Emissor:</label>
                          <div class="col-sm-8">
                            <input type="text" v-model="data.pessoa.pfRgOrgaoEmissor" class="form-control"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Expedição:</label>
                          <div class="col-sm-8">
                            <input type="text" v-model="data.pessoa.pfRgDataExpedicao" class="form-control"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-2 control-label">Nacionalidade</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-4">
                        <select class="form-control" v-model="data.pessoa.nacionalidade">
                          <option value="" disabled>Selecione</option>
                          <option :value="1">Brasileira</option>
                          <option :value="2">Estrangeira</option>
                        </select>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Estado Civil:</label>
                          <div class="col-sm-8">
                            <select class="form-control" v-model="data.pessoa.pfEstadoCivil">
                              <option value="" disabled>Selecione</option>
                              <option v-for="(ec, key) in getStatus.EstadoCivil" :value="key">{{ ec }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Sexo:</label>
                          <div class="col-sm-8">
                            <select class="form-control" v-model="data.pessoa.pfSexo">
                              <option value="" disabled>Selecione</option>
                              <option :value="1">Masculino</option>
                              <option :value="2">Feminino</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-2 control-label"></label>
                  <div class="col-sm-10">
                    <strong>Dados do Cônjuge</strong>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-2 control-label">Nome do Cônjuge</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-4">
                        <input type="text" v-model="data.conjugeNome" class="form-control"/>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">CPF:</label>
                          <div class="col-sm-8">
                            <input type="text" v-model="data.conjugeCpf" class="form-control"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">RG:</label>
                          <div class="col-sm-8">
                            <input type="text" v-model="data.conjugeRg" class="form-control"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div v-else>
                <!-- JURÍDICA -->
                <div class="form-group">
                  <label class="col-sm-2 control-label">CNPJ</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pessoa.pjCnpj" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Inscrição Estadual</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pessoa.pjInscricaoEstadual" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Nome Fantasia</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pessoa.pjNomeFantasia" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Razão Social</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pessoa.pjRazaoSocial" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Responsável</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pjProprietarioNome" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">CPF</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pjProprietarioCpf" class="form-control"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">RG</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="data.pjProprietarioRg" class="form-control"/>
                  </div>
                </div>
              </div>

              <!-- ENDEREÇO -->

              <div class="form-group">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <strong>Informações de Endereço</strong>
                </div>
              </div>


              <div v-for="endereco in data.pessoa.enderecos">
                <div class="form-group">
                  <label class="col-sm-2 control-label">CEP</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-2">
                        <input type="text" v-model="endereco.cep" class="form-control"/>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-sm-2 control-label">Endereço:</label>
                          <div class="col-sm-10">
                            <input type="text" v-model="endereco.logradouro" class="form-control"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Número:</label>
                          <div class="col-sm-8">
                            <input type="text" v-model="endereco.numero" class="form-control"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Bairro</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-4">
                        <input type="text" v-model="endereco.bairro" class="form-control"/>
                      </div>
                      <div class="col-sm-8">
                        <div class="form-group">
                          <label class="col-sm-3 control-label">Complemento:</label>
                          <div class="col-sm-9">
                            <input type="text" v-model="endereco.complemento" class="form-control"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- TODO: If uf.municipio... abrir aba de selação, se não, abrir cidadeOutros e ufOutros -->
                <div class="form-group">
                  <label class="col-sm-2 control-label">UF</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-4">
                        <input type="text" v-model="endereco.ufOutros" class="form-control"/>
                      </div>
                      <div class="col-sm-8">
                        <div class="form-group">
                          <label class="col-sm-2 control-label">Cidade:</label>
                          <div class="col-sm-10">
                            <input type="text" v-model="endereco.cidadeOutros" class="form-control"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group m-t-n">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <a class="btn btn-xs m-t-xs" @click="data.pessoa.enderecos.push(getTemplates.telefone)">Adicionar
                    endereço</a>
                </div>
              </div>

              <!-- CONTATO -->

              <div class="form-group">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <strong>Informações de Contato</strong>
                </div>
              </div>

              <div class="form-group" v-if="data.pessoa.emails && data.pessoa.emails.length > 0">
                <label class="col-sm-2 control-label">E-mail</label>
                <div class="col-sm-10">
                  <input type="text" v-model="data.pessoa.emails[0].email" class="form-control"/>
                </div>
              </div>

              <div class="form-group" v-for="(telefone, key) in data.pessoa.telefones">
                <label class="col-sm-2 control-label">Telefone {{ key+1 }}</label>
                <div class="col-sm-10">
                  <input type="text" v-model="telefone.telefone" class="form-control"/>
                </div>
              </div>
              <div class="form-group m-t-n">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <a class="btn btn-xs m-t-xs" @click="data.pessoa.telefones.push(getTemplates.telefone)">Adicionar
                    telefone</a>
                </div>
              </div>

              <!--<div class="form-group">
                <label class="col-sm-2 control-label">Telefone 2</label>
                <div class="col-sm-10">
                  <input type="text" v-model="telefones.telefone2" class="form-control"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Telefone 3</label>
                <div class="col-sm-10">
                  <input type="text" v-model="telefones.telefone3" class="form-control"/>
                </div>
              </div>-->

              <div class="form-group">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <strong>Informações Adicionais</strong>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Observações Internas</label>
                <div class="col-sm-10">
                  <textarea class="form-control" v-model="data.pessoa.observacao"></textarea>
                </div>
              </div>

              <div class="form-group" v-if="!data.id">
                <div class="col-sm-2"></div>
                <div class="col-sm-10">
                  <input id="forcaSenha" type="checkbox" v-model="forcarAlterarSenhaPrimeiroAcesso">
                  <label class="control-label" for="forcaSenha">Forçar usuário a alterar a senha no primeiro acesso</label>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-2"></div>
                <div class="col-sm-10">
                  <input id="consultaReboque" type="checkbox" v-model="permitidoSomenteConsultaReboque">
                  <label class="control-label" for="consultaReboque">Usuário restrito somente a consulta de reboque</label>
                </div>
              </div>

              <!--<div class="form-group">
                <label class="col-sm-2 control-label">Preferências</label>
                <div class="col-sm-10">

                </div>
              </div>-->

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default">Cancelar</u-button>
                <!--<span v-if="!data.id">Ao cadastrar, o status do lote será <span class="text-info">Rascunho</span>, para publicá-lo, altere o status após o cadastro.</span>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Usuario.vue?399fcb66